import {
    selectAppStateSlice,
} from '../../selectors';
import NAMESPACE from './types';

function selectSchedule(appState, scheduleId) {
    return selectAppStateSlice(appState)[NAMESPACE][scheduleId];
}

export {
    selectSchedule,
};
